import { Injectable,  } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { ConstantService } from "../utils/constant.service";
import { ClienteXCiudad, ConsultaMenu, Menu } from "../../../views/login/cliente_login";

@Injectable()
export class CabeceraEmpresaService {
    private usuarioEmpresa: ClienteXCiudad;
    private url="utils"
    constructor(private authHttp: AuthHttp) {
         let constantService = new ConstantService();  
         this.url = constantService.API_ENDPOINT + this.url;
         this.usuarioEmpresa = new ClienteXCiudad();
     }

    getNombreEmpresa(cliente: ClienteXCiudad): Observable<string> {
        this.usuarioEmpresa = cliente;
        let body = JSON.stringify(this.usuarioEmpresa);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url +"/getNombreUserEmpresa", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    getMenuXCliente(empresa: ClienteXCiudad, empresas: ClienteXCiudad[], cedula:string, codigoUsuario: number):Observable<Menu[]>{
        let consulta = new ConsultaMenu();
        consulta.Empresa = empresa;
        consulta.Empresas = empresas;
        consulta.Cedula = cedula;
        consulta.REG_COD = codigoUsuario;
        let body = JSON.stringify(consulta);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url +"/getMenuXCliente", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabeceraEmpresa/cabecera-empresa.service.ts